/**
 * Which queued request takes a freed slot of the global http queue (see `http-queue.service.ts`).
 * Only the pick from the queue is prioritised: an in-flight request is never aborted.
 * How many slots each priority may hold is set in `REQUEST_PRIORITY_SLOTS_CONFIG`.
 */
export enum RequestPriority {
  /** Default. Taken in FIFO order before `Medium` and `Low`. */
  High = 'high',
  /**
   * Takes free slots no `High` waits for, and has a guaranteed one: while none of it is in flight,
   * a freed slot goes to a waiting `Medium` first, even ahead of waiting `High` ones.
   * Meant for heavy background batches.
   */
  Medium = 'medium',
  /** Taken only when no `High` or `Medium` waits. Meant for data nobody waits for. */
  Low = 'low',
}
